import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5v6m0 3v1.5m0 3v.5","key":"svg-0"}],["path",{"d":"M16 9l-4 -4","key":"svg-1"}],["path",{"d":"M8 9l4 -4","key":"svg-2"}]]

const IconArrowNarrowUpDashed = createReactComponent('outline', 'arrow-narrow-up-dashed', 'ArrowNarrowUpDashed', __iconNode);

export default IconArrowNarrowUpDashed;